<div class="loading-area" *ngIf="!hidden">
    <div class="loading-box"></div>
    <div class="loading-pic">
        <div class="loading">
            <h2><img src="assets/images/footer-logo.png" alt="#"></h2>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
    </div>
</div>